<app-page-header icon="menu" title="Menúes ·" highlight="{{ modoCreacion ? 'Nuevo' : 'Editar' }}" subtitle="{{ modoCreacion ? 'Crear un nuevo menú en el sistema' : 'Modificar los datos del menú' }}"></app-page-header>

<div class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="cancelar()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="guardar()" class="form-card">
      <mat-form-field *ngIf="!modoCreacion" appearance="outline" class="full-width">
        <mat-label>Nombre en el sistema</mat-label>
        <input matInput [value]="nombreTraducido" readonly />
        <mat-hint>Nombre visible del diccionario. Solo lectura.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Identificador i18n</mat-label>
        <input matInput formControlName="name" placeholder="Ej: navbar.LI-CONFIG-TRAMITES" autocomplete="off" />
        <mat-error *ngIf="form.get('name')?.hasError('required')">El identificador es obligatorio</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Ruta</mat-label>
        <input matInput formControlName="redirectTo" placeholder="/centros-medicos-listado" autocomplete="off" />
        <mat-error *ngIf="form.get('redirectTo')?.hasError('required')">La ruta es obligatoria</mat-error>
      </mat-form-field>

      <div class="row-fields">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="tipo">
            <mat-option value="WEB">WEB</mat-option>
            <mat-option value="APP">APP</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Orden</mat-label>
          <input matInput type="number" formControlName="order" placeholder="1" min="1" />
          <mat-error *ngIf="form.get('order')?.hasError('min')">El orden debe ser mayor a 0</mat-error>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Ícono (clase CSS)</mat-label>
        <input matInput formControlName="icon" placeholder="bx bx-spreadsheet" autocomplete="off" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Padre</mat-label>
        <mat-select formControlName="parent">
          <mat-option [value]="null">Ninguno (raíz)</mat-option>
          <mat-option *ngFor="let m of opcionesPadre" [value]="m._id">
            <span [innerHTML]="indentarMenu(m)"></span>{{ nombreTraducidoMenu(m) }} <small>({{ m.redirectTo }})</small>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="form-actions">
        <button mat-stroked-button class="btn-cancelar" type="button" (click)="cancelar()">Cancelar</button>
        <button mat-stroked-button class="btn-guardar" type="submit" [disabled]="form.invalid">
          {{ modoCreacion ? 'Crear menú' : 'Guardar cambios' }}
        </button>
      </div>
    </form>
  </div>
</div>
